import http from '@/config/axios'
import Vue from "vue";
import store from '../../index';

export default {
    actions: {
        async getListPromocode(ctx) {
            const res = await http.get('/promocodes/list');
            ctx.commit('updatePromocodes', res.data.data.promocodes);
        },
        async createPromocode(ctx, data){
            const res = await http.post('/promocodes/create', data);
            if(res.data.result == 'ok'){
                ctx.commit('updatePromocodes', res.data.data.promocodes);
                store.state.modal.createPromocode = false;
                Vue.$toast.success(res.data.message);
            }else{
                Vue.$toast.error(res.data.message);
            }
        },
        async editPromocode(ctx, data){
            const res = await http.post('/promocodes/edit', data);
            if(res.data.result == 'ok'){
                ctx.commit('updatePromocodes', res.data.data.promocodes);
                store.state.modal.editPromocode = false;
                Vue.$toast.success(res.data.message);
            }else{
                Vue.$toast.error(res.data.message);
            }
        },
        async getPromocode(ctx, id){
            const res = await http.post('/promocodes/get?id=' + id);
            ctx.commit('updatePromocode', res.data.data.promocode);
        }
    },
    mutations: {
        updatePromocodes(state, data){
            state.promocodes = data;
        },
        updatePromocode(state, data){
            state.promocode = data;
        }
    },
    state: {
        promocodes: [],
        promocode: [],
    },
    getters: {
        promocodesInfo: state => state.promocodes,
        promocodeInfo: state => state.promocode,
    }
}